var map = {
	"./dark_SocialsInOne_fav.png": 619,
	"./dark_SocialsInOne_logo.png": 620,
	"./dark_bg-login.svg": 621,
	"./dark_dashboard_bg.jpg": 622,
	"./dark_dataak_fav.png": 623,
	"./dark_dataak_headlogo.svg": 624,
	"./dark_dataak_logo.svg": 625,
	"./dark_digitalMarketing_bg.jpg": 626,
	"./dark_irancell_labz_bg_login.svg": 627,
	"./dark_irancell_labz_favicon.png": 628,
	"./dark_irancell_labz_header_logo.svg": 629,
	"./dark_irancell_labz_logo.svg": 630,
	"./dark_kafir_fav.png": 631,
	"./dark_kafir_headlogo.png": 632,
	"./dark_manshour_fav.png": 633,
	"./dark_manshour_logo.png": 634,
	"./dark_matin_fav.png": 635,
	"./dark_matin_logo.png": 636,
	"./dark_mokhtar_fav.png": 637,
	"./dark_mokhtar_logo.png": 638,
	"./dark_pr_bg.jpg": 639,
	"./light_SocialsInOne_fav.png": 640,
	"./light_SocialsInOne_logo.png": 641,
	"./light_bg-login.svg": 642,
	"./light_dashboard_bg.jpg": 643,
	"./light_dataak_fav.png": 644,
	"./light_dataak_headlogo.svg": 645,
	"./light_dataak_logo.svg": 646,
	"./light_digitalMarketing_bg.jpg": 647,
	"./light_irancell_labz_bg_login.svg": 648,
	"./light_irancell_labz_favicon.png": 649,
	"./light_irancell_labz_header_logo.svg": 650,
	"./light_irancell_labz_logo.svg": 651,
	"./light_kafir_fav.png": 652,
	"./light_kafir_headlogo.png": 653,
	"./light_manshour_fav.png": 654,
	"./light_manshour_logo.png": 655,
	"./light_matin_fav.png": 656,
	"./light_matin_logo.png": 657,
	"./light_mokhtar_fav.png": 658,
	"./light_mokhtar_logo.png": 659,
	"./light_pr_bg.jpg": 660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1137;